import { createFeatureSelector, createSelector } from "@ngrx/store";
import { skuMetadataFeatureKey, SkuMetadataState } from "./sku-metadata.reducer";

export const getSkuMetadataStateFeature =
    createFeatureSelector<SkuMetadataState>(skuMetadataFeatureKey);

export const getSkuMetadataState = createSelector(
    getSkuMetadataStateFeature,
    (state: SkuMetadataState) => state
);